
class ModalTrigger extends HTMLButtonElement {

    constructor() {
        super();
    }
  
    async connectedCallback() {      
      console.log('Modal trigger button', this);
      this.addEventListener('click', this.clickHandler);
    }

    clickHandler = (event) => {
        event.preventDefault();

        console.log('Modal click handler', this.modalIsOpen, this.template);

        const content = this.template.content.cloneNode(true);

        this.modal.querySelector('.theme-modal__content').appendChild(content);

        if(this.modalIsOpen) this.closeModal();
        else this.openModal()
    }

    openModal() {
        console.log('Remove hidden from modal:' ,this.modal)
        this.modal.classList.remove('hidden');
    }

    closeModal() {
        this.modal.classList.add('hidden');        
        this.modal.querySelector('.theme-modal__content').innerHTML = '';
    }

    get modalIsOpen() {
        return !this.modal.classList.contains('hidden');
    }

    get modal() {
        return document.getElementById('theme-modal');
    }

    get template() {
        return document.getElementById(this.dataset.template)
    }
  }

  class ThemeModal extends HTMLDivElement {
  
      constructor() {
          super();
      }
    
      async connectedCallback() {      
        console.log('Modal', this);

        this.addEventListener('click', this.handleClick)
      }

      handleClick(event) {
        const $target = event.target;

        if(!this.contains($target) || !this.content.contains($target)) this.close()
      }

      close() {
        this.content.innerHTML = '';
        this.classList.add('hidden');
      }

      get content() {
        return this.querySelector('.theme-modal__content');
      }
  
    }
    
  


    customElements.define("theme-modal", ThemeModal, { extends: 'div' });

  customElements.define("modal-trigger", ModalTrigger, { extends: 'button' });
  